export default "__VITE_ASSET__01dcb83a__"